import InfoBlock from './InfoBlock.vue';

export { InfoBlock };
export default InfoBlock;
